import { useQuery } from '@tanstack/react-query';
import { headlessGet } from '../lib/api';
import type { CollectionListResponse } from '../types/cms';

const PAGE_SIZE = 4;

export function useCollection(typeSlug: string | undefined, page = 0) {
  return useQuery({
    queryKey: ['collection', typeSlug, page],
    queryFn: () =>
      headlessGet<CollectionListResponse>(
        `/collections/${encodeURIComponent(typeSlug!)}?limit=${PAGE_SIZE}&page=${page + 1}`,
      ),
    enabled: !!typeSlug,
    staleTime: 60_000,
    retry: false,
  });
}

export { PAGE_SIZE };
